export enum PendingEmailStatus {
  PENDING = 'PENDING',
  RETRYING = 'RETRYING',
  DISMISSED = 'DISMISSED',
  RESOLVED = 'RESOLVED',
}

export type PendingDisplayStatus = 'Delayed' | 'Overdue' | 'Retrying...' | 'Dismissed' | 'Resolved';

export interface RawPendingRow {
  id: number;
  status: PendingEmailStatus;
  reasonCode: string;
  createdAt: string;
  updatedAt: string;
  dismissedAt?: string;
  resolvedAt?: string;
  subject?: string;
  recipient?: string;
  recipientCc?: string;
  recipientBcc?: string;
  allRecipients?: string;
}

export interface PendingEmailRow {
  id: number;
  status: PendingEmailStatus;
  pendingDisplayStatus: PendingDisplayStatus;
  reasonCode: string;
  reasonDisplay: string;
  recommendedAction: string;
  subject: string;
  recipient: string;
  recipientCc: string;
  recipientBcc: string;
  allRecipients: string;
  createdAt: string;
  updatedAt: string;
  dismissedAt?: string;
  resolvedAt?: string;
  timeInQueue: string;
}
